import HighlightsItemSec from "./HighlightsItemSec";

export default HighlightsItemSec;
